import { formatMinutesSeconds } from '../../lib/format-minutes-seconds'
import { useAuthByPhoneContext } from '../auth-by-phone/auth-by-phone.context'
import { CodeInput } from '../code-input/code-input'
import { ResendButton } from '../resend-button/resend-button'
import { RuleNotation } from '../rule-notation/rule-notation'

import cl from './style.module.scss'

export const CodeByWebPush = () => {
	const { smsCode, smsCodeError, isLoading, isNewUser, resendCooldown, isCooldown, onCodeChange, requestSmsCode } =
		useAuthByPhoneContext()

	return (
		<div className={cl.root}>
			<div className={cl.wrapper}>
				<p className={cl.title}>Ожидайте пуш-уведомление</p>
				<p className={cl.subtitle}>Код вставится автоматически, как только придет пуш</p>
				<CodeInput inputCount={6} code={smsCode} onChange={onCodeChange} isError={!!smsCodeError} />
				{smsCodeError && <p className={cl.error}>{smsCodeError}</p>}
				{isNewUser && <RuleNotation />}
				<ResendButton onResend={requestSmsCode} isLoading={isLoading} isDisabled={isCooldown}>
					Запросить пуш с кодом через {formatMinutesSeconds(resendCooldown)}
				</ResendButton>
			</div>
		</div>
	)
}
